import { Link } from './link';
export class Item {
  id: number;
  name: string;
  selected: Boolean = false;
  link: Link;
}
